export default __webpack_public_path__ + "static/media/classmate.93ccd81a.png";